import React from 'react';
import { PDFDownloadLink, Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import ReactPDF from '@react-pdf/renderer';

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'row'
  },
  title: {
    padding: '20px 30px',
    fontSize: 20,
    marginBottom: 10
  },
  header: {
    fontSize: 16,
    padding: '20px 30px',
  },
  property: {
    fontSize: 12,
    paddingBottom: 3
  },
  preamble: {
    fontSize: 12,
    padding: '0 30px 0 30px',
  },
  text: {
    fontSize: 12,
    padding: '0 30px',
    lineHeight: '2rem'
  },
  section: {
    padding: 10
  }
});

const stripHtml = (input) => {
  return input.replaceAll('<br/>', '\r\n').replaceAll('<br>', '\r\n').replaceAll('<i>', '').replaceAll('<i/>', '').replaceAll('</i>', '');
}

// Create Document Component
const SbtPdf = ({ data }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View>
        <Text style={styles.title}>{data.content.titleFull}</Text>
        {!data.content.hideLawReportDetails &&
          <View style={{ paddingLeft: '30px' }}>
            <Text style={styles.property}>{data.content.isQuestionOrAnalysis ? 'Datum:' : 'Beslutsdatum:'} {data.content.decisionDate}</Text>
            {!data.content.isAnalysis &&<Text style={styles.property}>Pub. beteckning: {data.content.publication}</Text>}
            {data.content.caseNumber && <Text style={styles.property}>Målnr/Dnr: {data.content.caseNumber}</Text>}
            {data.content.organizations.length && <Text style={styles.property}>Organisationer: {data.content.organizations.join(',')}</Text>}
          </View>
        }
        {!data.content.isAnalysis && <Text style={styles.header}>Sammanfattning</Text>}
        {!data.content.isAnalysis && <Text style={styles.preamble}>{data.content.preamble.trim()}</Text>}
        {!data.content.isAnalysis && <Text style={styles.header}>Kommentar</Text>}

        {data.content.isAnalysis && <Text style={styles.header}></Text>}
        <Text style={styles.text}>{stripHtml(data.content.text.trim())}</Text>
      </View>
    </Page>
  </Document>
);


export default SbtPdf;